module.exports = __webpack_public_path__ + "static/media/sparta_planner_icon.55f9cfbe.svg";